import React, { useEffect, useState } from 'react'
import { subscription } from '../../../state';

interface SubscriptionProps {
        subscriptionData?: subscription | null;

    }

const SubscriptionHistoryWidget = ({subscriptionData}: SubscriptionProps) => {
  
    const [subscriptionPercentage, setSubscriptionPercentage] = useState<number>(0)

     useEffect(() => { 
      const actualSubscriptionPercentage = subscriptionData?.daysLeft as unknown as number /30 * 100
       setSubscriptionPercentage(actualSubscriptionPercentage)
     },[subscriptionData])

if(subscriptionData?.plan === undefined)
  return (
    <div className='relative flex flex-col gap-[12px] w-full lg:w-[50%]'>
      <p>No Active Plan</p>
      <div
      className='relative bg-[#ffffff] w-[80%] md:w-[70%] h-[7px]'
      />
    </div>
  )

  return (
    <div className='relative flex flex-col gap-[12px] w-full lg:w-[50%]'>
      <p>{subscriptionData?.daysLeft}/30</p>
      <div
      className={`relative bg-[#044E97] shadow-lg h-[7px]`}
      style={{width: `${subscriptionPercentage}`}}
      />
    </div>
  )
}

export default SubscriptionHistoryWidget